<template>
  <div class="keranjang">
    <NavbarItem :updatekeranjang="keranjangs"/>
    <div class="container">
      <div class="row mt-5">
        <div class="col">
          <nav aria-label="breadcrumb" style="margin-top:100px;">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/foods">Foods</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Cart</li>
            </ol>
          </nav>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <!-- <h2>keranjang <strong>Saya</strong></h2> -->

          
          <div class="row mt-4" v-for="(keranjang) in keranjangs" :key="keranjang.kera">
          <div class="col-4">
            <img :src="keranjang.gambar" class="img-fluid shadow" width="200px">
          </div>
          <div class="col-5">
            {{ keranjang.nama }}<br>
            <font color="red"><b>{{ formatRupiah(keranjang.harga) }}</b></font>
            <span class="text-muted"> × {{ keranjang.jumlah_pemesanan || 0 }}</span><br>
            <strong>{{ formatRupiah((Number(keranjang.harga) || 0) * (Number(keranjang.jumlah_pemesanan) || 0)) }}</strong>
            <div class="qty-control d-flex align-items-center">
              <button
                type="button"
                class="btn btn-outline-secondary btn-qty"
                :disabled="(keranjang.jumlah_pemesanan || 0) <= 1"
                @click="decrementQty(keranjang)"
              >
                −
              </button>
              <span class="qty-value">{{ keranjang.jumlah_pemesanan || 0 }}</span>
              <button
                type="button"
                class="btn btn-outline-secondary btn-qty"
                @click="incrementQty(keranjang)"
              >
                +
              </button>
            </div>
            <span>{{ keranjang.note ? keranjang.note :"-" }}</span>
          </div>
          <div class="col-3">
             <button class="btn btn-danger" @click="hapusKeranjang(keranjang.kera)"><b-icon-trash></b-icon-trash></button>
          </div>
          <div style="border-bottom:1px solid grey; margin-top:30px;"></div>
          </div>

          <div class="cart-fixed-spacer"></div>
        </div>
      </div>
    </div>

    <div class="cart-fixed-action">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong>Total Harga</strong>
          <strong class="cart-total-price">{{ formatRupiah(totalharga) }}</strong>
        </div>
        <button
          type="button"
          class="btn btn-success w-100 cart-fixed-btn"
          :disabled="keranjangs.length === 0 || checkoutLoading"
          @click="checkout"
        >
          <span v-if="checkoutLoading">Memproses...</span>
          <span v-else><b-icon-bag></b-icon-bag> Bayar sekarang</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarItem from "@/components/Navbar.vue";
import { api } from "@/utils/api";
import { formatRupiah } from "@/utils/formatRupiah";
import { buildPesananBody, formatPesananError, getPersonal, mapPaymentMethod, submitPesanan } from "@/utils/pesanan";

export default {
  nama: "keranjang",
  components: {
    NavbarItem,
  },

  data() {
    return {
      keranjangs: [],
      checkoutLoading: false,
      snapFinalizing: false,
    };
  },

  methods: {
    /** dotenv / .env sering punya spasi di awal/akhir baris — tanpa trim, Client Key invalid. */
    envTrim(key) {
      const v = process.env[key];
      return v == null ? "" : String(v).trim();
    },
    /** Midtrans / Laravel / custom API punya bentuk error berbeda. */
    formatMidtransRequestError(err) {
      const d = err.response?.data;
      if (d == null) return null;
      if (typeof d === "string") return d.slice(0, 500);
      if (Array.isArray(d.error_messages) && d.error_messages[0]) return d.error_messages[0];
      if (typeof d.message === "string" && d.message) return d.message;
      if (Array.isArray(d.message) && d.message.length) return d.message.join("; ");
      if (d.errors && typeof d.errors === "object") {
        const k = Object.keys(d.errors)[0];
        if (k) {
          const v = d.errors[k];
          return Array.isArray(v) ? v[0] : String(v);
        }
      }
      if (d.error != null) return String(d.error);
      return null;
    },
    formatRupiah,
    setKeranjangs(data) {
      this.keranjangs = data;
    },
    incrementQty(keranjang) {
      const newQty = (keranjang.jumlah_pemesanan || 0) + 1;
      this.updateQty(keranjang, newQty);
    },
    decrementQty(keranjang) {
      const current = keranjang.jumlah_pemesanan || 0;
      if (current <= 1) return;
      this.updateQty(keranjang, current - 1);
    },
    updateQty(keranjang, newQty) {
      keranjang.jumlah_pemesanan = newQty;
      const keranjangList = JSON.parse(localStorage.getItem("keranjang") || "[]");
      const item = keranjangList.find((i) => i.kera === keranjang.kera);
      if (item) item.jumlah_pemesanan = newQty;
      localStorage.setItem("keranjang", JSON.stringify(keranjangList));
    },
    hapusKeranjang(kera) {
      const keranjangList = JSON.parse(localStorage.getItem("keranjang") || "[]");
      const updated = keranjangList.filter((i) => i.kera !== kera);
      localStorage.setItem("keranjang", JSON.stringify(updated));
      this.setKeranjangs(updated);
      this.$toast.success("Berhasil di hapus", {
        position: "top-right",
        type: "success",
        duration: 3000,
        dismissible: true,
      });
    },

    async checkout() {
      if (this.keranjangs.length === 0) {
        this.$toast.error("Keranjang kosong", {
          position: "top-right",
          type: "error",
          duration: 3000,
          dismissible: true,
        });
        return;
      }
      const personal = getPersonal();
      if (!personal || !personal.clientToken) {
        this.$toast.error("Buka ulang dari link cafe/meja sebelum bayar.", {
          position: "top-right",
          type: "error",
          duration: 5000,
          dismissible: true,
        });
        return;
      }
      if (personal.meja == null || String(personal.meja).trim() === "") {
        this.$toast.error("Nomor meja tidak ada. Scan/buka ulang QR meja.", {
          position: "top-right",
          type: "error",
          duration: 5000,
          dismissible: true,
        });
        return;
      }
      const packed = buildPesananBody({ method: "qris" });
      if (packed.invalidDetails.length) {
        this.$toast.error("Ada item keranjang tanpa ID produk. Hapus lalu pesan ulang.", {
          position: "top-right",
          type: "error",
          duration: 5000,
          dismissible: true,
        });
        return;
      }

      this.checkoutLoading = true;
      try {
        const res = await api("/snapToken", {
          method: "POST",
          data: packed.body,
        });
        const body = res.data && typeof res.data === "object" ? res.data : {};
        const token = body.token || body.snap_token || null;
        const clientKey = body.client_key || this.envTrim("VUE_APP_MIDTRANS_CLIENT_KEY");
        const isProduction =
          typeof body.is_production === "boolean"
            ? body.is_production
            : this.envTrim("VUE_APP_MIDTRANS_IS_PRODUCTION") === "true";
        if (!token) {
          this.$toast.error("Gagal membuat token pembayaran", {
            position: "top-right",
            type: "error",
            duration: 3000,
            dismissible: true,
          });
          this.checkoutLoading = false;
          return;
        }
        if (!clientKey) {
          this.$toast.error("Client key Midtrans belum di-set di backend.", {
            position: "top-right",
            type: "error",
            duration: 5000,
            dismissible: true,
          });
          this.checkoutLoading = false;
          return;
        }
        if (body.order_id) {
          localStorage.setItem("midtrans_order_id", body.order_id);
        }
        localStorage.removeItem("midtrans_order_saved");
        localStorage.removeItem("midtrans_should_save");
        this.openSnapPay(token, clientKey, isProduction);
      } catch (err) {
        const fromBody = this.formatMidtransRequestError(err);
        const msg = fromBody || err.message || "Gagal membuat transaksi Midtrans";
        console.error("Midtrans snapToken gagal", err?.response?.data || err);
        this.$toast.error(msg, {
          position: "top-right",
          type: "error",
          duration: 6000,
          dismissible: true,
        });
        this.checkoutLoading = false;
      }
    },
    openSnapPay(token, clientKey, isProduction) {
      const snapScriptId = "midtrans-snap-script";
      const snapSrc = isProduction
        ? "https://app.midtrans.com/snap/snap.js"
        : "https://app.sandbox.midtrans.com/snap/snap.js";
      const existing = document.getElementById(snapScriptId);
      if (existing) {
        const sameSrc = existing.getAttribute("src") === snapSrc;
        const sameKey = existing.getAttribute("data-client-key") === clientKey;
        if (sameSrc && sameKey) {
          if (window.snap) {
            this.invokeSnapPay(token);
          } else {
            existing.addEventListener("load", () => this.invokeSnapPay(token));
          }
          return;
        }
        existing.remove();
        try {
          delete window.snap;
        } catch (e) {
          window.snap = undefined;
        }
      }
      const script = document.createElement("script");
      script.id = snapScriptId;
      script.src = snapSrc;
      script.setAttribute("data-client-key", clientKey);
      script.onload = () => this.invokeSnapPay(token);
      script.onerror = () => {
        this.$toast.error("Gagal memuat Midtrans Snap", { position: "top-right", type: "error", duration: 3000, dismissible: true });
        this.checkoutLoading = false;
      };
      document.body.appendChild(script);
    },
    mapMidtransMethod(result) {
      return mapPaymentMethod(result?.payment_type);
    },
    async submitPaidOrder(result) {
      if (this.snapFinalizing) {
        return;
      }
      this.snapFinalizing = true;
      const method = this.mapMidtransMethod(result);
      localStorage.setItem("midtrans_payment_method", method);
      localStorage.setItem("midtrans_payment_status", result?.transaction_status || "settlement");
      if (result) {
        localStorage.setItem("midtrans_payment_raw", JSON.stringify(result));
        if (result.order_id) {
          localStorage.setItem("midtrans_order_id", result.order_id);
        }
      }

      try {
        await submitPesanan({ method, result });
        localStorage.setItem("midtrans_order_saved", "1");
        this.setKeranjangs([]);
        this.$toast.success("Pembayaran berhasil, pesanan tercatat", {
          position: "top-right",
          type: "success",
          duration: 3000,
          dismissible: true,
        });
        this.$router.push({ path: "/pesanan-sukses", query: { saved: "1" } });
      } catch (err) {
        this.snapFinalizing = false;
        console.error("Gagal simpan pesanan", err?.response?.data || err);
        this.$toast.error(formatPesananError(err), {
          position: "top-right",
          type: "error",
          duration: 8000,
          dismissible: true,
        });
        this.$router.push({ path: "/pesanan-sukses", query: { saved: "0" } });
      } finally {
        this.checkoutLoading = false;
      }
    },
    invokeSnapPay(token) {
      const vm = this;
      if (!window.snap || typeof window.snap.pay !== "function") {
        vm.$toast.error("Midtrans Snap belum siap", { position: "top-right", type: "error", duration: 3000, dismissible: true });
        vm.checkoutLoading = false;
        return;
      }
      window.snap.pay(token, {
        onSuccess(result) {
          localStorage.setItem("midtrans_should_save", "1");
          vm.submitPaidOrder(result);
        },
        onPending(result) {
          localStorage.setItem("midtrans_should_save", "1");
          if (result?.order_id) {
            localStorage.setItem("midtrans_order_id", result.order_id);
          }
          if (result?.payment_type) {
            localStorage.setItem("midtrans_payment_method", vm.mapMidtransMethod(result));
          }
          vm.checkoutLoading = false;
        },
        onError() {
          vm.checkoutLoading = false;
          vm.$toast.error("Pembayaran gagal atau dibatalkan", { position: "top-right", type: "error", duration: 3000, dismissible: true });
        },
        onClose() {
          if (vm.snapFinalizing || localStorage.getItem("midtrans_order_saved") === "1") {
            vm.checkoutLoading = false;
            return;
          }
          if (localStorage.getItem("midtrans_should_save") === "1") {
            vm.submitPaidOrder({
              order_id: localStorage.getItem("midtrans_order_id"),
              payment_type: localStorage.getItem("midtrans_payment_method"),
              transaction_status: localStorage.getItem("midtrans_payment_status") || "pending",
            });
            return;
          }
          vm.checkoutLoading = false;
        },
      });
    },
  },

  mounted() {
    const data = JSON.parse(localStorage.getItem("keranjang") || "[]");
    this.setKeranjangs(data);
  },

  computed: {
    totalharga() {
      return this.keranjangs.reduce((sum, item) => {
        const harga = Number(item.harga) || 0;
        const qty = Number(item.jumlah_pemesanan) || 0;
        return sum + harga * qty;
      }, 0);
    },
  },
};
</script>

<style scoped>
.qty-control {
  gap: 0.35rem;
  margin: 0.25rem 0;
}
.qty-control .btn-qty {
  width: 2rem;
  padding: 0.25rem 0;
  font-size: 1.1rem;
  line-height: 1;
}
.qty-value {
  min-width: 1.5rem;
  text-align: center;
  font-weight: 600;
}

.cart-fixed-action {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 58px;
  z-index: 30;
  background: #fff;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
  padding: 0.75rem 0 calc(0.75rem + env(safe-area-inset-bottom));
}

.cart-total-price {
  color: #dc3545;
  font-size: 1.1rem;
}

.cart-fixed-btn {
  min-height: 44px;
}

.cart-fixed-spacer {
  height: 140px;
}
</style>